import { Box, Icon, Spacer, Text, TextNew } from '@jfs/ui-new'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { staticStrings } from '../../data/static/strings'
import { RootStore, useStores } from '../../data/store'
import { BulkBeneficiaryFileSelector } from './BulkBeneficiaryFileSelector'
import { BulkBeneficiaryUploadFileProgress } from './BulkBeneficiaryUploadFileProgress'
import { stylesFile } from './styles'

interface FileUploadProps {
  tabIndex: number
  onFileSelected: any
  mid: string
  progress: any
  name: any
  onHandleCancelChangeFile: any
  navToHistory: any
  handleDownloadSampFile: any
  file: any
  resetState: any
  onHandleAddBeneficiaries: any
}

const BulkBeneficiaryFileUpload = ({
  tabIndex,
  onFileSelected,
  mid,
  progress,
  name,
  onHandleCancelChangeFile,
  navToHistory,
  handleDownloadSampFile,
  file,
  resetState,
  onHandleAddBeneficiaries,
}: FileUploadProps) => {
  const { uploadStatus } = useStores((store) => ({
    uploadStatus: store?.beneficiaryOnboarding?.uploadStatus,
  }))

  const themedStyle = stylesFile(0)

  const { REACT_APP_ENDPOINT = '' } = (window?._env_ ?? {})

  return (
    <Box bg={'WHITE'} p={24} borderRadius={8}>
      <Box flexDirection={'row'} align={'center'} justify={'space-between'}>
        <Text fontFamily="jiotype-bold" color={'BLACK_21'} fontSize={16}>
          {staticStrings.bulkBeneficiaryLabel}
        </Text>
        <Box underlayColor={'TRANSPARENT'} onPress={resetState} testID="resetState">
          <Icon id={'CLOSE'} color={'BLACK_21'} size={20} />
        </Box>
      </Box>
      <Spacer size={16} />
      <Box flexDirection={'row'} align={'center'} justify={'space-between'}>
        <ModBox>
          <Text fontSize={12} fontFamily={'jiotype-medium'} color={'BLACK_75'}>
            {'File format should be as per the sample file'}
          </Text>
        </ModBox>
        <a
          href={`${REACT_APP_ENDPOINT}/sample_bulk_beneficiary_onboarding.xlsx`}
          style={{ textDecoration: 'none' }}
          rel="noopener noreferrer"
          target="_blank">
          <Box flexDirection={'row'} align={'center'}>
            <Icon id={'DOWNLOAD'} color={'BLUE'} />
            <Spacer size={8} direction={'horizontal'} />
            <TextNew fontFamily={'jiotype-medium'} fontSize={14} color={'BLUE'}>
              {staticStrings.downloadSampleFile}
            </TextNew>
          </Box>
        </a>
      </Box>
      <Spacer size={16} direction={'vertical'} />
      {uploadStatus === 'NOT_SELECTED' && (
        <Box alignItems={'center'} justifyContent={'center'}>
          <BulkBeneficiaryFileSelector
            onFileSelect={onFileSelected}
            mid={mid}
            onError={(err: string) => RootStore?.response?.setMessage(err)}
            resetState={resetState}
            onHandleCancelChangeFile={onHandleCancelChangeFile}
            onHandleAddBeneficiaries={onHandleAddBeneficiaries}
          />
        </Box>
      )}
      {uploadStatus !== 'NOT_SELECTED' && (
        <BulkBeneficiaryUploadFileProgress
          progress={progress}
          fileName={name ?? ''}
          onHandleCancelChangeFile={onHandleCancelChangeFile}
          mid={mid}
          navToHistory={navToHistory}
          file={file}
          resetState={resetState}
        />
      )}
    </Box>
  )
}

export { BulkBeneficiaryFileUpload }
